import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { CONSTANTS } from "app/constants";
import { LeftMenuItem } from "app/models";
import { Subscription } from "rxjs";

@Component({
    selector: 'admin-left-side-menu',
    templateUrl: './admin-left-side-menu.html',
    styleUrls: ['../../layouts/admin/admin.layout.scss', './admin-left-side-menu.scss'],
})
export class AdminLeftSideMenu implements OnInit, OnDestroy {
    menuItems: LeftMenuItem[] = [];

    active: boolean = false;
    private routerSubscription: Subscription;
    
    constructor(private router: Router) {
        this.buildMenuItems();
    }

    ngOnInit(): void {
        this.detectCurrentRoute(this.router.url);
        
        this.routerSubscription = this.router.events.subscribe((val) => {
            if(val instanceof NavigationEnd) {
                this.detectCurrentRoute(val.urlAfterRedirects);
            }
        });
    }

    ngOnDestroy(){
        this.routerSubscription.unsubscribe();
    }

    goTo(menuItem: LeftMenuItem) {
        this.router.navigate([menuItem.route]);
    }

    private buildMenuItems() {
        this.menuItems = [];

        let drawingItems = [];
        drawingItems.push(this.buildMenuItem("Еврокубки", CONSTANTS.routes.admin.euroCup, false, false, null));
        drawingItems.push(this.buildMenuItem("Суперкубок Европы", CONSTANTS.routes.admin.drawingEuroSuperCup, false, false, null));
        drawingItems.push(this.buildMenuItem("Второй круг 16 команд", CONSTANTS.routes.admin.secondTour16, false, false, null));
        drawingItems.push(this.buildMenuItem("Второй круг 12 команд", CONSTANTS.routes.admin.secondTour12, false, false, null));
        drawingItems.push(this.buildMenuItem("Нац. кубки", CONSTANTS.routes.admin.drawindNationalCups, false, false, null));
        drawingItems.push(this.buildMenuItem("Нац. супер кубки", CONSTANTS.routes.admin.drawingNationalSuperCups, false, false, null));
        drawingItems.push(this.buildMenuItem("ЧМ. Финал. Группы", CONSTANTS.routes.admin.drawingWCFinal, false, false, null));
        drawingItems.push(this.buildMenuItem("ЧМ. Плей-офф", CONSTANTS.routes.admin.drawingWCPlayoff, false, false, null));
        drawingItems.push(this.buildMenuItem("ЧМ. Отбор", CONSTANTS.routes.admin.drawingWCQual, false, false, null));
        drawingItems.push(this.buildMenuItem("КЧМ. Группы", CONSTANTS.routes.admin.drawingClubWCGroup, false, false, null));
        drawingItems.push(this.buildMenuItem("КЧМ. Плей-офф", CONSTANTS.routes.admin.drawingClubWCPlayoff, false, false, null));
        drawingItems.push(this.buildMenuItem("Карусель", CONSTANTS.routes.admin.drawingCarousel, false, false, null));

        this.menuItems.push(this.buildMenuItem("Статистика", CONSTANTS.routes.admin.dashboard, false, false, null));
        this.menuItems.push(this.buildMenuItem("Игровые дни", CONSTANTS.routes.admin.matchDays, false, false, null));
        this.menuItems.push(this.buildMenuItem("Жеребьевка", null, false, true, drawingItems));
        this.menuItems.push(this.buildMenuItem("Пользователи", CONSTANTS.routes.admin.users, false, false, null));
        this.menuItems.push(this.buildMenuItem("Логи", CONSTANTS.routes.admin.jobLogs, false, false, null));
        this.menuItems.push(this.buildMenuItem("Обслуживание", CONSTANTS.routes.admin.maintenance, false, false, null));
    }

    private buildMenuItem(label: string, route: string, isSelected: boolean, isDropDown: boolean, children: LeftMenuItem[]): LeftMenuItem {
        let result =  new LeftMenuItem();

        result.label = label;
        result.route = route;
        result.isSelected = isSelected;
        result.isDropdown = isDropDown;
        if (isDropDown) {
            result.childrenItems = children;
        }

        return result;
    }

    private detectCurrentRoute(url: string){
        url = url.substring(1);
        let parts = url.split(';');
        url = parts[0];

        this.menuItems.forEach(item=> {
           item.isSelected = item.route === url;
        });
    }

}